module.exports = __webpack_public_path__ + "img/yc-pointer-4.png";